import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Signal,
} from '@angular/core';
import { MenuComponent, MenuItemComponent } from '@lyceo/shared/ui';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
  IconDefinition,
  faHouse,
  faEllipsis,
  faArrowRightFromBracket,
  faCardsBlank,
  faCalendarDays,
  faUser,
} from '@fortawesome/pro-solid-svg-icons';
import { TranslocoDirective } from '@jsverse/transloco';
import { AuthFacade } from '@lyceo/shared/auth/data-access';
import { MenuController } from '@ionic/angular/standalone';
import { Permission } from '@lyceo/homi/shared/util-models';
import { TtFeatureFlagDirective } from '@techniek-team/feature-flags';
import { FeatureFlag } from '@lyceo/shared/util-models';
import { UserFacade } from '@lyceo/homi/user/data-access';

@Component({
  selector: 'homi-menu-bar',
  templateUrl: './menu-bar.component.html',
  styleUrls: ['./menu-bar.component.scss'],
  imports: [
    MenuComponent,
    MenuItemComponent,
    FaIconComponent,
    TranslocoDirective,
    TtFeatureFlagDirective,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuBarComponent {
  private readonly authFacade: AuthFacade = inject(AuthFacade);
  private readonly menuController: MenuController = inject(MenuController);
  private readonly userFacade: UserFacade = inject(UserFacade);

  protected readonly faHouse: IconDefinition = faHouse;
  protected readonly faEllipsis: IconDefinition = faEllipsis;
  protected readonly faArrowRightFromBracket: IconDefinition =
    faArrowRightFromBracket;
  protected readonly faCardsBlank: IconDefinition = faCardsBlank;
  protected readonly faCalendarDays: IconDefinition = faCalendarDays;
  protected readonly faUser: IconDefinition = faUser;
  protected readonly Permission: typeof Permission = Permission;
  protected readonly FeatureFlag: typeof FeatureFlag = FeatureFlag;
  protected readonly personId: Signal<string | undefined> =
    this.userFacade.personId;

  protected logout(): void {
    this.authFacade.userLogout();
  }

  protected moreMenu(): void {
    this.menuController.toggle('more-menu');
  }
}
